<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title40"></a>
<div class="p-c"><span><em class="i">For Teresita</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429997973_ded01.vue?53e8cec3